import styles from '../../testrun.module.css'

const STATUS_CLASS = {
    Pass: styles.statusPass,
    Passed: styles.statusPass,
    Fail: styles.statusFail,
    Pending: styles.statusPending,
    Retest: styles.statusRetest,
}

export function StatusPill({ status }) {
    const cls = STATUS_CLASS[status] || styles.statusDefault
    return <span className={cls}>{status || 'N/A'}</span>
}

export default StatusPill
